import { debounce } from 'lodash-es'
import { useEmptyModal } from '../empty'
import Player from '@/components/libpag/index.vue'

export const usePagPlayer = debounce((record: Record<string, any>) => {
  useEmptyModal({
    closable: true,
    width: 1280,
    maskClosable: true,
    content: (
      <Player
        url={record.file_url}
        audioUrl={record?.config?.audioUrl}
        autoplay={true}
      />
    ),
  })
}, 200)
